import CIMSFormItem from 'components/CIMSFormItem'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import ConcurrenceLevelsFormItem from './components/ConcurrenceLevelsFormItem'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { HelpMessage } from 'utils/constants'
import CIMSSection from 'components/CIMSSection'

const CommonFormItems: React.FC = ({ children }) => {
  const { event } = useCIMSNotificationsPanelContext()
  const help = HelpMessage.FieldDesignChanges.Notifications
  return (
    <>
      <CIMSSection
        title={`Every ${event.name} Event`}
        help={HelpMessage.Notifications.Every(event, 'Field Design Change')}
      >
        <CIMSFormItem label="Recipients" name="recipients">
          <RecipientsSelect />
        </CIMSFormItem>
      </CIMSSection>
      <CIMSSection
        title="Concurrence Levels"
        help={help.ByConcurrenceLevel(event)}
      >
        <CIMSFormItem name="concurrenceLevels">
          <ConcurrenceLevelsFormItem />
        </CIMSFormItem>
      </CIMSSection>
      {children}
    </>
  )
}

export default CommonFormItems
